export type LocationActionTypes = UpdateLocationAction

type UpdateLocationAction = {
  type: typeof UPDATE_LOCATION
  location: LocationWithActionAndQuery
}
export const UPDATE_LOCATION = 'UPDATE_LOCATION'
export function updateLocation(location: LocationWithActionAndQuery): UpdateLocationAction {
  return {
    type: UPDATE_LOCATION,
    location,
  }
}
